import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PlantAction } from '../../@commons/@services/data/garden-todo.store';
import { ActionBadgeComponent } from '../../@commons/ui-components/action-badge/action-badge.component';
import { CheckRowComponent } from '../../@commons/ui-components/check-row/check-row.component';
import { LabelPipe } from '../../@commons/pipes/LabelPipe';
import { LocationLabelPipe } from '../../@commons/pipes/location-label.pipe';
import { DEFAULT_CULTIVATION_IMAGE, lastFileUrl } from '../../garden/@components/last-file-url.util';

/**
 * Une plante qui attend un geste, dans « Pour tes plantes » (maquette 02) : le
 * titre est le nom de l'étape qui l'attend (décision 15), la variété et la
 * zone dessous ; la vignette garde le badge du potager, on reconnaît la même
 * action partout. Sur la ligne à cocher commune : le rond coche, la ligne
 * ouvre la fiche de la plante.
 */
@Component({
  selector: 'vw-plant-action-row',
  standalone: true,
  imports: [TranslatePipe, ActionBadgeComponent, CheckRowComponent],
  templateUrl: './plant-action-row.component.html',
  // Bloc : sans cela l'hôte est en ligne et le `divide-y` du parent ne trace aucun filet entre les lignes.
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PlantActionRowComponent {
  @Input() action: PlantAction;
  @Input() checked = false;
  @Output() check = new EventEmitter<void>();
  @Output() open = new EventEmitter<void>();

  private readonly label = new LabelPipe();
  private readonly locationLabel = new LocationLabelPipe();

  get title(): string {
    return this.label.transform(this.action.nextStep.name);
  }

  /** « Cœur de bœuf, Mini-serre » : la variété et la zone, sans virgule orpheline quand l'une manque. */
  get subtitle(): string {
    const plant = this.action.plant;
    return [this.label.transform(plant.cultivationVariant?.name), this.locationLabel.transform(plant.location?.name)]
      .filter(Boolean)
      .join(', ');
  }

  /** Le nom du rond : deux repiquages ne se confondent pas au lecteur d'écran. */
  get checkLabel(): string {
    return [this.title, this.subtitle].filter(Boolean).join(', ');
  }

  get imageUrl(): string {
    return lastFileUrl(this.action.plant.cultivationVariant, DEFAULT_CULTIVATION_IMAGE);
  }
}
